import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../../components/global/Button';

const propTypes = {
  eventCollage: PropTypes.shape({
    album_custom_print: PropTypes.shape({
      custom_print: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
      album: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  }).isRequired,
  onConfigure: PropTypes.func.isRequired,
  className: PropTypes.string,
};
const EventCollageItem = ({ eventCollage, onConfigure, className }) => {
  const classes = classNames({
    'event-collage-item': true,
    [className]: !!className,
  });

  const { album_custom_print: albumCustomPrint } = eventCollage;
  const { custom_print: customPrint, album } = albumCustomPrint;

  return (
    <div className={classes}>
      <div className="event-collage-item-preview">
        {customPrint.preview_image && (
          <img
            src={customPrint?.preview_image?.url}
            alt="Event Collage Preview"
          />
        )}
        {!customPrint.preview_image && <p>Template preview</p>}
      </div>
      <div className="event-collage-item-content">
        <h4>{customPrint.name}</h4>
        <p className="text-dark">
          Put your photos from {album.name} together in this special collage
          template
        </p>
        <Button pill btnOutline btnSize="sm" onClick={onConfigure}>
          Configure now
        </Button>
      </div>
    </div>
  );
};

EventCollageItem.propTypes = propTypes;

export default EventCollageItem;
